import Constants from 'expo-constants'
import { Platform } from 'react-native'
import { getWindowHostname, shouldUseSameOriginDevApi } from './devTunnel'

// Web E2E: Playwright injects window.__WARCARP_API_URL__ via addInitScript
// before the bundle loads so tests target the test API on :3001. The
// EXPO_PUBLIC_* env-substitution path is broken in our current build —
// see https://github.com/expo/expo/issues/... — until that's fixed, this
// runtime hook is the reliable override.
function runtimeOverride(key: string): string | undefined {
  if (typeof globalThis === 'undefined') return undefined
  const value = (globalThis as Record<string, unknown>)[key]
  return typeof value === 'string' ? value : undefined
}

/**
 * Same-origin API when a DEV web bundle is served from a non-localhost host
 * (ngrok/cloudflared tunnel, LAN IP) — see lib/devTunnel.ts. The __DEV__ gate
 * guarantees release builds can never take this branch.
 */
function devTunnelOrigin(): string | undefined {
  if (typeof __DEV__ === 'undefined' || !__DEV__) return undefined
  return shouldUseSameOriginDevApi(Platform.OS, getWindowHostname())
    ? window.location.origin
    : undefined
}

export const API_URL =
  runtimeOverride('__WARCARP_API_URL__') ??
  process.env.EXPO_PUBLIC_API_URL ??
  (Constants.expoConfig?.extra?.apiUrl as string | undefined) ??
  devTunnelOrigin() ??
  // Local-dev default: the API process binds to :4101 in apps/api/.env
  // (the web dev server runs on :8181 — both moved off the common
  // 3001/8081 to avoid clashing with other local projects). Playwright
  // overrides this via EXPO_PUBLIC_API_URL=http://localhost:3001 for its
  // own test API. Production builds get the real URL injected at build time.
  'http://localhost:4101'

// Storage keys (without prefix — prefix is applied in lib/storage.ts)
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'ACCESS_TOKEN',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  // Last-known user, cached so a cold start can hydrate the authed UI
  // immediately (and survive an offline launch) before /auth/me validates.
  USER: 'USER',
  // Device-local preference: the off-turn chat bar over the game log shown
  // (the map bar's log-chat button on phones). Absent = shown. A fresh key
  // (the old GAME_CHAT_MODE could hold 'false' from an earlier toggle), so
  // everyone starts with it shown.
  GAME_CHAT_BAR_OFF_TURN: 'GAME_CHAT_BAR_OFF_TURN',
  // Device-local preference: in-game tips minimized to their one-line title row.
  TUTORIAL_TIPS_COLLAPSED: 'TUTORIAL_TIPS_COLLAPSED',
  // Last attack-report expansion choice, suffixed with the viewing account ID.
  ATTACK_LOG_EXPANDED: 'ATTACK_LOG_EXPANDED',
} as const
